import React from "react";

export default function Footer() {
  return (
    <div className="flex flex-col mt-8 justify-center">
      <div className="h-1 bg-gray-medium w-full"></div>
      <p className="text-md text-center text-white py-6">© 2022 Designed and Developed by suhail k k</p>
    </div>
  );
}
